// Where a family's page is its surface's colour (spec ui-perf/theme-page-surface-split). Its own
// module, with no family files, so the e2e reads the same rule (e2e/brand-logo.spec.ts).
import { contrast, mix } from "./color";
import type { Seeds } from "./family";

/** How far a page that is its surface's colour moves toward its text (spec ui-perf/theme-page-surface-split). */
export const PAGE_SPLIT = 0.05;

/** WCAG AA for text, the contrast gate's bar for muted text on the page (`contrast.ts`). */
const MUTED_AA = 4.5;

/**
 * A variant whose page is its surface's colour draws a card, a panel or Pro's page invisible on
 * it, so its page moves `PAGE_SPLIT` of the way toward its text (and its muted text as far as it
 * must to stay readable there); any other variant is as imported.
 */
export function splitPage(seeds: Seeds): Seeds {
  if (seeds.page.toLowerCase() !== seeds.surface.toLowerCase()) return seeds;
  const page = mix(seeds.text, seeds.surface, PAGE_SPLIT);
  // Muted text that read just above AA on the surface (Everforest's) may fall under it on the new
  // page: it moves toward the text, a percent at a time, until it reads 4.5:1 there again.
  let muted = seeds.muted;
  for (let step = 1; contrast(muted, page) < MUTED_AA && step <= 100; step += 1) {
    muted = mix(seeds.text, seeds.muted, step / 100);
  }
  return { ...seeds, page, muted };
}
